import CryptoJS from "crypto-js";

/**
 * DES 解密
 * @param {string} ciphertext - 加密的密文
 * @param {string} key - 解密密钥
 * @returns {string} 解密后的明文
 */
export function decryptByDES(ciphertext, key) {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Hex.parse(ciphertext),
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  const result_value = decrypted.toString(CryptoJS.enc.Utf8);
  return result_value;
}
